<div class="full-column">
	<app-hub-nav-header
		sportCode="golf"
		currentRoute="h2h"
	></app-hub-nav-header>
    <div class="page-description" >
		<h1 class="page-title"> Golf H2H Matchup Tool </h1>
		<app-page-intro-copy *ngIf="trustedDesc" [html]="trustedDesc"></app-page-intro-copy>
	</div>
    
    <div class="golf-toggles">
        <div>
            
        </div>
    
        <div class="prob-toggle" (click)="toggleProbabilityOption()">
            <div class="prob-option">
                Fair Odds
            </div>
            <div class="prob-indicator">
                <div class="inner" [class.left]="probabilityOption === 'odds'" [class.right]="probabilityOption === 'percent'"></div>
            </div>
            <div class="prob-option">
                Percentages
            </div>
        </div>
    
        
    </div>
    
    <div class="h2h-selector-ctr">
        <div class="h2h-title">
            <span *ngIf="golfH2HLoading || golfH2HError">H2H Matchup Predictor</span>
            <span *ngIf="!golfH2HLoading && !golfH2HError">H2H Matchup Predictor - {{ tournamentData.tournamentName }}</span>
        </div>
        <div class="h2h-selector-loading" *ngIf="golfH2HLoading">
            Loading...
        </div>
        <div class="h2h-selector-loading" *ngIf="!golfH2HLoading && golfH2HError">
            <span>Sorry, something went wrong. Please <span class="retry-link" (click)="getGolfH2HMatrix()">try again</span>.</span>
        </div>
        <div class="h2h-selector" *ngIf="!golfH2HLoading && !golfH2HError">
            <div class="h2h-dropdown-row">
                <!-- Player A -->
                <div class="h2h-dropdown">
                    <div class="h2h-dropdown-button" (click)="toggleH2HPlayerADropdown()">
                        <span class="name">{{ h2hPlayerA.playerFirstName }} {{ h2hPlayerA.playerLastName }}</span>
                        
                        <fa-icon [icon]="faAngleDown"></fa-icon>
                    </div>
                    <div class="h2h-dropdown-options" *ngIf="h2hPlayerADropdownOpen">
                        <div class="h2h-search-ctr">
                            <input type="text" class="h2h-search-bar" [(ngModel)]="h2hSearches.playerA" placeholder="Search players..." (keyup)="calculateSelectablePlayers()">
                        </div>
                        <div class="h2h-dropdown-option" *ngFor="let player of selectablePlayers[0]"
                            (click)="setH2HPlayer(1, player)">{{ player.playerFirstName }} {{ player.playerLastName }}</div>
                    </div>
                </div>
                <!-- Player B -->
                <div class="h2h-dropdown">
                    <div class="h2h-dropdown-button" (click)="toggleH2HPlayerBDropdown()">
                        <span class="name">{{ h2hPlayerB.playerFirstName }} {{ h2hPlayerB.playerLastName }}</span>
                        
                        <fa-icon [icon]="faAngleDown"></fa-icon>
                    </div>
                    <div class="h2h-dropdown-options" *ngIf="h2hPlayerBDropdownOpen">
                        <div class="h2h-search-ctr">
                            <input type="text" class="h2h-search-bar" [(ngModel)]="h2hSearches.playerB" placeholder="Search players..." (keyup)="calculateSelectablePlayers()">
                        </div>
                        <div class="h2h-dropdown-option" *ngFor="let player of selectablePlayers[1]"
                            (click)="setH2HPlayer(2, player)">{{ player.playerFirstName }} {{ player.playerLastName }}</div>
                    </div>
                </div>
            </div>
    
            <div class="h2h-no-matchup" *ngIf="golfH2HNoMatchup">
                Sorry, matchup data for this pairing is not currently available. Please select a different pair of players.
            </div>
    
            <div class="h2h-round-selector" *ngIf="!golfH2HNoMatchup">
                <div class="h2h-round-option" [class.selected-option]="h2hRoundOption === 'r1'" (click)="setH2HRoundOption('r1')">
                    Round 1
                </div>
                <div class="h2h-round-option" [class.selected-option]="h2hRoundOption === 'all'" (click)="setH2HRoundOption('all')">
                    Tournament
                </div>
            </div>
            <div class="h2h-results" *ngIf="!golfH2HNoMatchup">
                <div class="h2h-result left">
                    <app-flag-icon [countryCode]="countryLookup[(h2hPlayerA.playerCountry | uppercase) || ''] || ''"></app-flag-icon>
                    <span class="h2h-win-pct">{{ h2hProbDisplay(1) }}</span>
                </div>
                <div class="h2h-tie">
                    <span class="h2h-tie-pct">{{ h2hProbDisplay(0) }}</span>
                    <span class="h2h-tie-label">Tie</span>
                </div>
        
                <div class="h2h-result right">
                    <app-flag-icon [countryCode]="countryLookup[(h2hPlayerB.playerCountry | uppercase) || ''] || ''"></app-flag-icon>
                    <span class="h2h-win-pct">{{ h2hProbDisplay(2) }}</span>
                </div>
            </div>
        </div>
        
        <div class="h2h-futures-list" *ngIf="!golfH2HLoading && !golfH2HError">
            <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.winner, 1) }}</div>
                <div class="h2h-futures-label">To Win Tournament</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.winner, 1) }}</div>
            </div>
            <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.top5, 1) }}</div>
                <div class="h2h-futures-label">Top 5</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.top5, 1) }}</div>
            </div>
            <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.top10, 1) }}</div>
                <div class="h2h-futures-label">Top 10</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.top10, 1) }}</div>
            </div>
            <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.top20, 1) }}</div>
                <div class="h2h-futures-label">Top 20</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.top20, 1) }}</div>
            </div>
            <!-- <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.top40, 1) }}</div>
                <div class="h2h-futures-label">Top 40</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.top40, 1) }}</div>
            </div>
            <div class="h2h-futures-row">
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerA.makeCut, 1) }}</div>
                <div class="h2h-futures-label">Make Cut</div>
                <div class="h2h-futures-pct">{{ probConversion(h2hPlayerB.makeCut, 1) }}</div>
            </div> -->
        </div>
    </div>

    <app-best-offers sportCode="GOLF" *ngIf="environment.optionalFeatures.includes('best-offers')"></app-best-offers>
    <div class="description" *ngIf="trustedCopy" [innerHTML]="trustedCopy"></div>
</div>